import {
  SlOption
} from "./chunk.4L6M7RA3.js";

// src/components/option/option.ts
var option_default = SlOption;
SlOption.define("sl-option");

export {
  option_default
};
